import React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import { PayPalButtons } from "@paypal/react-paypal-js";

import { cancelSubscription, reviseSubscription } from "./auth/updateUser";

enum Mode {
  Initial,
  Confirm,
  Success,
  Error,
}

const useCancelSubscriptionDialog = () => {
  const [mode, setMode] = React.useState(Mode.Initial);
  const [open, setOpen] = React.useState(false);
  const [targetPlanId, setTargetPlanId] = React.useState<string>();
  const [consentUrl, setConsentUrl] = React.useState<string>();
  const [loading, setLoading] = React.useState<boolean>(false);

  const handleClose = () => {
    setMode(Mode.Initial);
    setOpen(false);
  };

  const initial = mode === Mode.Initial;
  const confirm = mode === Mode.Confirm;
  const success = mode === Mode.Success;
  const error = mode === Mode.Error;

  const handleConfirm = () => {
    setMode(Mode.Confirm);
  };

  const handleSubscriptionCancel = () => {
    setLoading(true);
    cancelSubscription()
      .then((result) => {
        // Read result of the Cloud Function.
        var sanitizedMessage = result.data.text;
        setMode(Mode.Success);
      })
      .catch(() => {
        setMode(Mode.Error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    openCancelSubscriptionDialog: (targetPlanId) => {
      setTargetPlanId(targetPlanId);
      setOpen(true);
      // reviseSubscription({ planId: targetPlanId })
      //   .then((data: any) => {
      //     setMode(Mode.Confirm);
      //     console.log("data", data.data.confirmationUrl);

      //     setConsentUrl(data.data.confirmationUrl);
      //   })
      //   .catch(() => {
      //     setMode(Mode.Error);
      //   });
    },
    dialog: (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <DialogContent>
          {initial && (
            <>
              <Typography sx={{ marginTop: 2, marginBottom: 3 }} align="center">
                Tem certeza de que deseja cancelar sua assinatura? Você pode assinar novamente a qualquer momento.
              </Typography>

              <Box marginX={2} textAlign="center">
                {loading ? (
                  <CircularProgress />
                ) : (
                  <Button onClick={handleSubscriptionCancel} color="primary" variant="outlined">
                    Sim, desejo cancelar
                  </Button>
                )}
              </Box>
            </>
          )}

          {/* {confirm && (
            <>
              <Typography sx={{ marginTop: 2, marginBottom: 3 }} align="center">
                Clique no botão abaixo para confirmar a mudança de plano junto ao Paypal
              </Typography>

              <Box marginX={2} display="flex" justifyContent="center">
                <Button
                  onClick={() => {
                    console.log("opening consent", consentUrl);

                    window.open(consentUrl, "consentSubscriptionPlanChange", "popup");
                  }}
                  variant="contained"
                  color="primary"
                >
                  Confirmar mudança de plano
                </Button>
              </Box>
            </>
          )} */}

          {success && (
            <>
              <Typography sx={{ marginTop: 2, marginBottom: 3 }} align="center">
                Concluído!
              </Typography>
            </>
          )}

          {error && (
            <>
              <Typography sx={{ marginTop: 2 }} align="center">
                Algo deu errado :(
              </Typography>

              <Typography sx={{ marginBottom: 3 }} align="center">
                Tente novamente ou entre em contato conosco
              </Typography>
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Fechar
          </Button>

          {/* {initial && (
            <Button
              onClick={() => {
                handleConfirm();
              }}
              variant="contained"
              color="primary"
            >
              Sim!
            </Button>
          )} */}
        </DialogActions>
      </Dialog>
    ),
  };
};

export { useCancelSubscriptionDialog };
